<div class="chart-detail-container">
  <div class="header">
    <h2>{{ notificationInfo.title || 'Chart Details' }}</h2>
    <p class="notification-body" *ngIf="notificationInfo.body">{{ notificationInfo.body }}</p>
  </div>

  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">

    <div class="chart-category" *ngFor="let config of chartConfigs; trackBy: trackByCategory"
      [attr.data-category]="config.Category">

      <div class="category-header">
        <div class="header-content">
          <h3>{{ config.Title }}</h3>
          <p class="chart-description" *ngIf="config.Description">{{ config.Description }}</p>
        </div>
        <span class="chart-type-badge" [attr.data-type]="config.ChartType">
          {{ config.ChartType | titlecase }}
        </span>
      </div>

      <div class="chart-container" [attr.data-chart-type]="config.ChartType">

        <div class="bar-chart" *ngIf="config.ChartType === 'bar'">
          <div class="bar-item" *ngFor="let item of config.Data; trackBy: trackByChartId">
            <div class="bar-label">{{ item.Label }}</div>
            <div class="bar-visual">
              <div class="bar-fill" [style.width.%]="(item.Value / getMaxValue(config.Data)) * 100"
                [style.background-color]="item.Color">
              </div>
              <span class="bar-value">{{ formatValue(item.Value, config.ValueSuffix) }}</span>
            </div>
            <div class="bar-meta">
              <span class="target">Cíl: {{ formatValue(item.Target, config.ValueSuffix) }}</span>
              <span class="variance" [class]="getVarianceClass(item.Variance)">
                {{ item.Variance > 0 ? '+' : '' }}{{ item.Variance.toFixed(1) }}%
              </span>
              <span class="trend" [class]="getTrendClass(item.Trend)">
                <mat-icon>{{ getTrendLabel(item.Trend, config.ChartType) }}</mat-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="pie-chart" *ngIf="config.ChartType === 'pie'">
          <div class="pie-legend" *ngIf="config.ShowLegend">
            <h4>{{ 'CHARTS.LEGEND' | translate }}</h4>
          </div>
          <div class="pie-data">
            <div class="pie-item" *ngFor="let item of config.Data; trackBy: trackByChartId">
              <div class="pie-color" [style.background-color]="item.Color"></div>
              <div class="pie-info">
                <div class="pie-label">{{ item.Label }}</div>
                <div class="pie-value">
                  {{ formatValue(item.Value, config.ValueSuffix) }}
                  <span class="percentage" *ngIf="config.ShowPercentages && item.Percentage">
                    ({{ formatPercentage(item.Percentage) }})
                  </span>
                </div>
                <div class="pie-trend">
                  <span class="target">
                    {{ 'CHARTS.GOAL' | translate }}{{ formatValue(item.Target,config.ValueSuffix)}}
                  </span>
                  <span class="variance" [class]="getVarianceClass(item.Variance)">
                    {{ item.Variance > 0 ? '+' : '' }}{{ item.Variance.toFixed(1) }}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="line-chart" *ngIf="config.ChartType === 'line'">
          <div class="line-item" *ngFor="let item of config.Data; trackBy: trackByChartId">
            <div class="line-point" [style.background-color]="item.Color">
              <div class="point-label">{{ item.Label }}</div>
              <div class="point-value">{{ formatValue(item.Value, config.ValueSuffix) }}</div>
              <div class="point-meta">
                <span class="target">vs {{ formatValue(item.Target, config.ValueSuffix) }}</span>
                <span class="trend" [class]="getTrendClass(item.Trend)">
                  {{ getTrendLabel(item.Trend, config.ChartType) | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-chart" *ngIf="config.ChartType === 'summary'">
          <div class="summary-item" *ngFor="let item of config.Data; trackBy: trackByChartId">
            <div class="summary-header">
              <h4>{{ item.Label }}</h4>
              <span class="summary-trend" [class]="getTrendClass(item.Trend)">
                {{ getTrendLabel(item.Trend, config.ChartType) | translate}}
              </span>
            </div>
            <div class="summary-values">
              <div class="summary-actual">
                <span class="label">{{ 'CHARTS.ACTUAL' | translate }}:</span>
                <span class="value">{{ formatValue(item.Value, config.ValueSuffix) }}</span>
              </div>
              <div class="summary-target">
                <span class="label">{{ 'CHARTS.GOAL' | translate }}:</span>
                <span class="value">{{ formatValue(item.Target, config.ValueSuffix) }}</span>
              </div>
              <div class="summary-difference">
                <span class="label">{{ 'CHARTS.DIFFERENCE' | translate }}:</span>
                <span class="value" [class]="getVarianceClass(item.Value - item.Target)">
                  {{ formatValue(getAbsoluteValue(item.Value - item.Target), config.ValueSuffix) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="custom-chart" *ngIf="!['bar', 'pie', 'line', 'summary'].includes(config.ChartType)">
          <p>{{ 'CHARTS.THISTYPE' | translate }} "{{ config.ChartType }}" {{ 'CHARTS.IMPLEMENTATION' | translate }}</p>
          <pre>{{ config | json }}</pre>
        </div>

      </div>
    </div>

    <div class="no-data" *ngIf="chartConfigs.length === 0">
      <p>{{ 'CHARTS.NOGRAPHSTOSHOW' | translate }}</p>
    </div>

    <div class="metadata" *ngIf="notificationInfo.created">
      <small>{{ 'GLOBAL.CREATED' | translate }} {{ notificationInfo.created | date:'dd.MM.yyyy HH:mm' }}</small>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'CHARTS.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>
